import { DatagridResponsive } from "..";
import { DatagridContainer } from "../components/container/styles";
import { IDatagridSimple } from "../types";

export const DatagridCombo: React.FC<IDatagridSimple> = ({
  navigateTable,
  handleDelete,
  handleEdit,
  handleDownload,
  headers,
  data,
  count,
  hasCheckbox,
  rowHeader,
  loading,
  orderBy,
  page,
  renderExpandedRow,
  disableHeight = false
}) => {
  return (
    <>
      <DatagridContainer disableHeight={disableHeight}>
        <DatagridResponsive.Container>
          <div className="desktop">
            <DatagridResponsive.Default
              handleDownload={handleDownload}
              navigateTable={navigateTable}
              handleDelete={handleDelete}
              hasCheckbox={hasCheckbox}
              handleEdit={handleEdit}
              headers={headers}
              loading={loading}
              orderBy={orderBy}
              count={count}
              data={data}
              page={page}
              renderExpandedRow={renderExpandedRow}
            />
          </div>
          <div className="mobile">
            <DatagridResponsive.Mobile
              handleDownload={handleDownload}
              navigateTable={navigateTable}
              handleDelete={handleDelete}
              hasCheckbox={hasCheckbox}
              handleEdit={handleEdit}
              rowHeader={rowHeader}
              headers={headers}
              loading={loading}
              orderBy={orderBy}
              count={count}
              data={data}
              page={page}
              renderExpandedRow={renderExpandedRow}
            />
          </div>
        </DatagridResponsive.Container>
      </DatagridContainer>
    </>
  );
};
